<template>
  <skud-guest-view />
</template>

<script>
import SkudGuestView from '@/views/skud/components/SkudGuestView.vue'

export default {
  name: 'ClientSkudGuestPage',
  components: { SkudGuestView }
}
</script>
